"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.rag.description': 'Configure los parámetros RAG (Generación Aumentada por Recuperación) para el procesamiento de conocimiento por IA',
    'settings.rag.failedToLoad': 'Error al cargar la configuración RAG',
    'settings.rag.savedSuccessfully': 'Configuración RAG guardada exitosamente',
    'settings.rag.failedToSave': 'Error al guardar la configuración RAG',
    'settings.rag.save': 'Guardar Configuración RAG',
    'settings.rag.indexing.title': 'Configuración de Indexación',
    'settings.rag.indexing.chunkSize': 'Tamaño de Fragmento',
    'settings.rag.indexing.chunkSize.help': 'Número máximo de caracteres por fragmento de texto (100-10000)',
    'settings.rag.indexing.chunkOverlap': 'Superposición de Fragmentos',
    'settings.rag.indexing.chunkOverlap.help': 'Número de caracteres superpuestos entre fragmentos (0-1000)',
    'settings.rag.indexing.separators': 'Separadores de Texto',
    'settings.rag.indexing.separators.placeholder': 'Ingrese separadores separados por comas (ej. .\\n\\n, \\n)',
    'settings.rag.indexing.separators.help': 'Caracteres o cadenas utilizados para dividir texto en fragmentos. Use \\n para saltos de línea, \\t para tabulaciones. Separe múltiples valores con comas.',
    'settings.rag.search.title': 'Configuración de Búsqueda',
    'settings.rag.search.defaultMaxResults': 'Máximo de Resultados por Defecto',
    'settings.rag.search.defaultMaxResults.help': 'Número predeterminado de resultados de búsqueda a devolver (1-50)',
    'settings.rag.search.maxResults': 'Máximo de Resultados',
    'settings.rag.search.maxResults.help': 'Número máximo de resultados de búsqueda permitidos (1-100)',
    'settings.rag.search.similarityThreshold': 'Umbral de Similitud',
    'settings.rag.search.similarityThreshold.help': 'Puntuación mínima de similitud para resultados de búsqueda (0-1)',
};
